import React, { useState } from "react";
import "../Assets/CSS/Footer.css";
import "../Assets/CSS/Styles.scss";
import logo from "../Assets/Images/logo.png";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Footer = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const footerLinks = [
    {
      title: "Solutions",
      items: [
        "School ERP",
        "College ERP",
        "Trust Management",
        "Analytics Dashboard",
        "Mobile App",
      ],
    },
    {
      title: "Company",
      items: ["About Us", "Why Choose Us", "Careers", "Press"],
    },
    {
      title: "Resources",
      items: ["Blog", "Case studies", "News", "Events"],
    },
    {
      title: "Support",
      items: [
        "Help Center",
        "Documentation",
        "Training",
        "Contact Support",
        "System Status",
      ],
    },
  ];

  const footerRouteMap = {
    // Company
    "About Us": "/about-us",
    "Why Choose Us": "/about-us#why-choose-us",
    Careers: "/careers",
    Press: null,

    // Resources
    Blog: "/blog",
    "Case studies": "/casestudies",
    News: "/news",
    Events: null,

    // Solutions (disabled)
    "School ERP": null,
    "College ERP": null,
    "Trust Management": null,
    "Analytics Dashboard": null,
    "Mobile App": null,

    // Support
    "Help Center": null,
    Documentation: null,
    Training: null,
    "Contact Support": "/contact#contactForm", // ✅ Updated
    "System Status": null,
  };

  // ✅ Reusable Link Renderer
  const renderLink = (item, closeAccordion = false) => {
    const route = footerRouteMap[item];

    if (!route) {
      return (
        <span
          className="opacity-60 cursor-not-allowed"
          title="Coming soon"
        >
          {item}
        </span>
      );
    }

    // If route contains hash → use HashLink
    if (route.includes("#")) {
      return (
        <HashLink
          smooth
          to={route}
          onClick={() => closeAccordion && setActiveAccordion(null)}
        >
          {item}
        </HashLink>
      );
    }

    // Normal route → use NavLink
    return (
      <NavLink
        to={route}
        onClick={() => closeAccordion && setActiveAccordion(null)}
      >
        {item}
      </NavLink>
    );
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          {/* Desktop Layout */}
          <div className="hidden lg:flex lg:flex-row lg:justify-between lg:gap-8 w-full">
            <div className="flex-1">
              <div className="footer-logo">
                <NavLink to="/">
                  <img
                    src={logo}
                    alt="Global Solutions Logo"
                    className="logo"
                  />
                </NavLink>
                <div className="social-icons">
                  <FaFacebookF />
                  <FaTwitter />
                  <FaLinkedinIn />
                  <FaInstagram />
                </div>
              </div>
            </div>

            {footerLinks.map((section, idx) => (
              <div key={idx} className="flex-1">
                <h4 className="text-[17px] font-heading font-bold mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  {section.items.map((item, index) => (
                    <li
                      key={index}
                      className="font-ui hover:text-[#f7b500] cursor-pointer"
                    >
                      {renderLink(item)}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Mobile Accordion */}
          <div className="lg:hidden w-full">
            <div className="flex-1">
              <div className="footer-logo">
                <NavLink to="/">
                  <img
                    src={logo}
                    alt="Global Solutions Logo"
                    className="logo"
                  />
                </NavLink>
                <div className="social-icons">
                  <FaFacebookF />
                  <FaTwitter />
                  <FaLinkedinIn />
                  <FaInstagram />
                </div>
              </div>
            </div>

            {footerLinks.map((section, index) => (
              <div
                key={index}
                className="mb-2 border-b border-[#1e293b]"
              >
                <button
                  className="w-full flex justify-between items-center py-4 text-left"
                  onClick={() => toggleAccordion(index)}
                >
                  <h4 className="text-[16px] font-bold">
                    {section.title}
                  </h4>
                  {activeAccordion === index ? (
                    <FaChevronUp />
                  ) : (
                    <FaChevronDown />
                  )}
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${activeAccordion === index
                    ? "max-h-96"
                    : "max-h-0"
                    }`}
                >
                  <ul className="space-y-2 text-sm text-gray-300 pb-4">
                    {section.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="font-ui hover:text-[#f7b500] cursor-pointer"
                      >
                        {renderLink(item, true)}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p className="text-[13px] font-ui">
              © Copyright Global Solutions 2025. All rights
              reserved.
            </p>
            <div className="policy-links">
              <span className="text-[13px] font-ui">
                Privacy Policy
              </span>
              <span className="text-[13px] font-ui">
                Terms of Service
              </span>
              <span className="text-[13px] font-ui">
                Cookie Policy
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
